// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jw-0";
export var discountCodeInput = "_jw-1";